import gql from "graphql-tag"
import fullMerchantProductPermissions from "../fragments/merchantProductPermissions"

const query = gql`
  query ResumeMerchant {
    productPermissions {
      ...fullMerchantProductPermissions
    }
  }
  ${fullMerchantProductPermissions}
`

export const toString = query.loc.source.body

export default query
